// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Zf6fG","tab":"Tabs_tab__wJ5b1","tabActive":"Tabs_tabActive__2pa9J"};